module.exports = __webpack_public_path__ + "static/media/import.9ebe94d0.svg";